export class WorkoutSelectionReview {
    public reviewerName: string;
    public lastUpdated: Date;
}
